module.exports = __webpack_public_path__ + "img/m04.06acd3c7.png";